export default class UserGroupSelectionShortModel {
  constructor(public groupId: string,
    public groupIsSelected: boolean
  ) { }
}